// extracted by mini-css-extract-plugin
export var cancelRequestButton = "LegalEntityNameChangeStatus-module__cancelRequestButton___Mo-Eb";
export var contextualStoreBackgroundDark = "#1a1b1e";
export var duration = "LegalEntityNameChangeStatus-module__duration___Nedwj";
export var learnMoreButton = "LegalEntityNameChangeStatus-module__learnMoreButton___Jebnk";
export var modal = "LegalEntityNameChangeStatus-module__modal___IQL9n";
export var modalActions = "LegalEntityNameChangeStatus-module__modalActions___0l4px";
export var modalBusyOverlay = "LegalEntityNameChangeStatus-module__modalBusyOverlay___+DgEV";
export var modalHeader = "LegalEntityNameChangeStatus-module__modalHeader___WkbHv";
export var resendActions = "LegalEntityNameChangeStatus-module__resendActions___MeB7B";
export var resendButton = "LegalEntityNameChangeStatus-module__resendButton___hcFOj";
export var status = "LegalEntityNameChangeStatus-module__status___F-uE0";
export var statusAttached = "LegalEntityNameChangeStatus-module__statusAttached___Njku9";
export var statusBusyOverlay = "LegalEntityNameChangeStatus-module__statusBusyOverlay___3iW7M";
export var statusContent = "LegalEntityNameChangeStatus-module__statusContent___iFn9x";
export var statusFlush = "LegalEntityNameChangeStatus-module__statusFlush___MPtej";
export var statusHeading = "LegalEntityNameChangeStatus-module__statusHeading___vWTu6";